// Instellingen als overzicht (Arabisch). Zelfde vorm als settingsHub.nl.ts.
export const appSettingsHubAr = {
    groups: {
        family: {
            title: 'عائلتنا',
            titleHouse: 'بيتنا',
            body: 'من ينتمي إليكم، واللغة، وما يناسبكم.',
        },
        agenda: {
            title: 'التقويم',
            body: 'أضيفوا تقويمات من الخارج، وشاركوا وصدّروا.',
        },
        board: {
            title: 'اللوحة والأجهزة اللوحية',
            body: 'الأجهزة اللوحية على الحائط، والغرف، والقفل، والطقس.',
        },
        modules: {
            title: 'الوحدات',
            body: 'الأجزاء التي تستخدمونها، ولكل منها إعداداته.',
        },
        account: {
            title: 'حسابك',
            body: 'تسجيل الدخول والأمان، والإشعارات على هاتفك، وشكل التطبيق.',
        },
        privacy: {
            title: 'الخصوصية والبيانات',
            body: 'نزّل بياناتك أو امسحها، واختر من يُسمح له بالاطلاع.',
        },
    },
    household: {
        title: 'الأسرة',
        intro: 'الاسم واللغة ونوع الأسرة في مكان واحد.',
        nameTitle: 'الاسم والمنطقة الزمنية',
        nameBody: 'يظهر الاسم على اللوحة وفي رسائل البريد الإلكتروني.',
    },
    calendar: {
        title: 'ربط التقويم وتصديره',
        intro: 'روابط الاشتراك، ومدة الطريق، والتقويم كملف.',
    },
    locationWeather: {
        title: 'الموقع والطقس',
        intro: 'أين تسكنون، وما تعرضه اللوحة عن الطقس.',
    },
    // WP3: vijf onderdelen, Bord en Gezin met tabbladen.
    sections: {
        label: 'أقسام الإعدادات',
        household: 'الأسرة المنزلية',
        family: 'العائلة والتقاليد',
        house: 'ما يناسب بيتنا',
        agenda: 'التقويم',
        modules: 'الوحدات',
        account: 'الحساب والخصوصية',
        accountState: 'الأمان والإشعارات والمظهر وبياناتك',
    },
    change: 'تغيير',
    /** Rechts in een regel die alleen uitleg opent (geen keuze). */
    view: 'عرض',
    rows: {
        name: 'الاسم والمنطقة الزمنية',
        language: 'اللغة',
        type: 'نوع الأسرة',
        location: 'الموقع',
        weather: 'الطقس على اللوحة',
        feeds: 'تقويمات خارجية',
        feedsState: 'المدرسة والرياضة والعمل في تقويمكم',
        sync: 'ربط Google أو Outlook',
        syncState: 'في الاتجاهين، لكل شخص',
        links: 'روابط الاشتراك',
        linksState: 'تقويمكم في تطبيق آخر (اتجاه واحد)',
        export: 'تصدير',
        exportState: 'التقويم كملف (.ics)',
        theme: 'المظهر والرموز',
        about: 'عن AMUMIN',
        off: 'متوقف',
        nothing: 'لم يُختر شيء بعد',
        ownChoices: 'اختيارات خاصة: {names}',
    },
    hubs: {
        board: {
            title: 'اللوحة',
            tabs: 'أقسام اللوحة',
            view: 'العرض',
            tablets: 'الأجهزة اللوحية',
            rooms: 'الغرف',
            frame: 'إطار الصور',
            kidLock: 'قفل الأطفال',
        },
        family: {
            title: 'العائلة',
            tabs: 'أقسام العائلة',
            members: 'الأفراد',
            links: 'الأقارب',
            circle: 'الدائرة',
        },
    },
    tablets: {
        none: 'لا يوجد جهاز لوحي مرتبط بعد.',
        guide: 'كيف تربط جهاز iPad',
    },
    members: {
        order: 'الترتيب',
        orderDone: 'تم',
    },
    modulesCount: '{on} من {total} مفعّلة',
    privacyStatement: 'بيان الخصوصية',
    privacyStatementBody: 'ما نحتفظ به، ولماذا، وإلى متى.',
    haptics: {
        label: 'الاهتزاز عند اللمس',
        hint: 'اهتزاز قصير عندما تضغط على شيء (فقط على هاتف يدعم ذلك).',
        boardHint: 'اهتزاز قصير عندما يضغط أحد على شيء في اللوحة. جهاز iPad لا يهتز؛ لكنك ترى الضغط عليه.',
    },
};
//# sourceMappingURL=settingsHub.ar.js.map